export default {
  betslip: {
    en: 'Betslip',
  },
  myBets: {
    en: 'My bets',
  },
}
